import { CompetitorListQueryParams } from "../../../../models/competitors-query.model";

export const getFormModel = (query: CompetitorListQueryParams) => {
  return {
    name: query.name || undefined,
    active: query.active || undefined,
  };
};
